export default (type) => {
  if (type === 'project') {
    return 'mdi-briefcase'
  }
  if (type === 'dataset' | type === 'DS') {
    return 'mdi-book-open-blank-variant'
  }
  if (type === 'scenario' | type === 'SC') {
    return 'mdi-movie'
  }
  if (type === 'transaction' | type === 'TR') {
    return 'mdi-swap-horizontal-bold'
  }
  if (type === 'questionnaire' | type === 'QQ') {
    return 'mdi-comment-question'
  }
  if (type === 'conceptMap' | type === 'CM') {
    return 'mdi-map-marker-distance'
  }
  if (type === 'valueSet' | type === 'VS') {
    return 'mdi-heart'
  }
  if (type === 'codeSystem' | type === 'CS') {
    return 'mdi-format-list-bulleted-type'
  }
  if (type === 'browsableCodeSystem') {
    return 'mdi-format-list-bulleted-type'
  }
  if (type === 'template' | type === 'TM') {
    return 'mdi-recycle'
  }
  if (type === 'profile') {
    return 'mdi-fire'
  }
  return 'mdi-origin'
}
